import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { numberFormat } from "../../../../helpers/numberFormat";
import { PrincipalLayouts } from "../../../../layouts"
import { fetchData } from "../../../helpers/getData/fetchData";
import { DistributionFundTable } from "./DistributionFundTable";
import { ViewFundsTable } from "./ViewFundsTable";


export const ViewFunds = () => {

  const { t } = useTranslation('global')
  const location = useLocation();
  const [fundList, setFundList] = useState('isLoading')
  const [distributionList, setDistributionList] = useState('isLoading')
  const [reloadData, setReloadData] = useState(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    fetchData(setFundList, `/investmentsFunds?fund=${searchParams.get('fund')}`, t);
    fetchData(setDistributionList, `/fundDistributions?id=${searchParams.get('fund')}`, t);
  }, [reloadData, location.search, t])

  return (
    <PrincipalLayouts>
      {
        (fundList !== 'isLoading' && distributionList !== 'isLoading') &&
        <Stack gap={8}>
          <ViewFundsTable rows={fundList} setReloadData={setReloadData} distributionList={distributionList} totalAmount={fundList?.map(fund => fund.amount).reduce((a, b) => a + b, 0)} />
          {
            fundList.length > 0 &&
            <Stack direction='row' flexWrap='wrap' justifyContent='space-around' sx={{ border: '1px solid #EA7F22', padding: '15px 0' }}>
              <Stack direction='row' flexWrap='wrap' justifyContent='center'>
                <Typography color='primary' variant='subtitle1' sx={{marginRight:'5px'}}>{t('funds.amount')}:</Typography>
                <Typography color='secondary' variant='subtitle1'>{numberFormat(fundList?.map(fund => fund.amount).reduce((a, b) => a + b, 0))} </Typography>
              </Stack>
              <Stack direction='row' flexWrap='wrap' justifyContent='center'>
                <Typography color='primary' variant='subtitle1' sx={{marginRight:'5px'}}>{t('funds.percentage')}:</Typography>
                <Typography color='secondary' variant='subtitle1'> {fundList[0]?.percentagePaid}%</Typography>
              </Stack>
              <Stack direction='row' flexWrap='wrap' justifyContent='center'>
                <Typography color='primary' variant='subtitle1' sx={{marginRight:'5px'}}>{t('funds.amountPaid')}:</Typography>
                <Typography color='secondary' variant='subtitle1'>{numberFormat((fundList.map(fund => fund.amount).reduce((a, b) => a + b, 0) * (fundList[0].percentagePaid / 100)))}</Typography>
              </Stack>
            </Stack>
          }
          <DistributionFundTable rows={distributionList} setReloadData={setReloadData} />
        </Stack>
      }
    </PrincipalLayouts>
  )
}
